const nullToEmptyString = (value: null | string): string =>
  value === null ? '' : value;

export default nullToEmptyString;
